import { makeAutoObservable } from 'mobx'

export class FrameStore {
  width = 0
  height = 0

  constructor() {
    makeAutoObservable(this)
    this.update()
    window.addEventListener('resize', this.update)
  }

  get tablet(): boolean {
    return this.width < 1024
  }

  update = () => {
    this.width = window.innerWidth
    this.height = window.innerHeight
  }
}
